import login from '../functions/login';
import logout from '../functions/logout';
import { axiosInstance } from '../functions/axios';
import { getSubPath } from '../config/config';
import {blobToBase64} from '../functions/blobToBase64'

// Action called when viewport size changed
export const footerHeightChanged = (height) => {
    return {
        type: 'FOOTER_HEIGHT_CHANGED',
        payload: height,
    };
};

const subPath = getSubPath(window.location.pathname);
var BSM_AUTH_URL = process.env.REACT_APP_BSM_AUTH_URL;
var BSM_AUTH_URL_LOCAL = process.env.REACT_APP_BSM_AUTH_URL_LOCAL;
export const validateCredentials = (emailId, regCode, userType, qid, answer) => {
    return async (dispatch, getState) => {
        dispatch({
            type: 'VALIDATE_CREDENTIALS_REQUEST',
            payload: {
                emailId: emailId,
                isLogged: false,
            },
        });
        try {
            if (process.env.NODE_ENV === 'development') {
                BSM_AUTH_URL = BSM_AUTH_URL_LOCAL;
            }
            console.log('ATTEMPTING LOGIN');
            const bsmResponse = await axiosInstance.post(
                BSM_AUTH_URL,
                JSON.stringify({
                    emailId: emailId,
                    password: regCode,
                    userType: userType,
                    qid: qid,
                    answer: answer,
                })
            );
            if (bsmResponse.status === 200) {
                let registeredUser = false;
                let mobileDetails = {
                    maskedMobileNo: bsmResponse.data.maskedMobileNo,
                    mobileConfirmation: bsmResponse.data.mobileConfirmation,
                };
                let allowDelete = bsmResponse.data.allowDeletion;
                console.log('DATA recieved is ', bsmResponse.data);
                console.log('User type is ', bsmResponse.data.type);
                if (bsmResponse.data.type === 'REGISTERED') {
                    registeredUser = true;
                } else {
                    registeredUser = false;
                }
                dispatch({
                    type: 'VALIDATE_CREDENTIALS_SUCCESS',
                    payload: {
                        emailId: emailId,
                        isLogged: true,
                        registeredUser: registeredUser,
                        mobileDetails: mobileDetails,
                        allowDelete: allowDelete,
                    },
                });
            }
        } catch (error) {
            console.log(`Logging ${BSM_AUTH_URL} error `, error);
            console.log('Error will be handled by interceptor');
        }
    };
};

const BSM_LOGOUT_URL = process.env.REACT_APP_BSM_LOGOUT_URL;
export const logoutUser = (data) => {
    return async (dispatch, getState) => {
        dispatch({
            type: 'LOGOUT_REQUEST',
        });
        try {
            console.log('Calling Logout API');
            const response = await logout(subPath + BSM_LOGOUT_URL);
            console.log('Logout API Called');
            dispatch({
                type: 'LOGOUT_SUCCESS',
                payload: {
                    emailId: '',
                    isLogged: false,
                    error: data,
                    registeredUser: false,
                    mobileDetails: {
                        maskedMobileNo: null,
                        mobileConfirmation: null,
                    },
                    allowDelete: null,
                    customerLogo: null,
                    calledLogoApi: false,
                },
            });
        } catch (error) {
            console.log('Logging Logout failure', error);
            dispatch({
                type: 'LOGOUT_ERROR',
                error: error,
            });
        }
    };
};

export const sessionTimeout = () => {
    return async (dispatch, getState) => {
        try {
            const response = await logout(subPath + BSM_LOGOUT_URL);
            dispatch({
                type: 'TIMEOUT',
                payload: {
                    emailId: '',
                    isLogged: false,
                    registeredUser: false,
                    mobileDetails: {
                        maskedMobileNo: null,
                        mobileConfirmation: null,
                    },
                    showTimeoutPopup: true,
                },
            });
        } catch (error) {
            console.error(`Error while logging out is `, error);
        }
    };
};

export const clearTimeoutPopup = () => {
    return {
        type: 'CLEAR_TIMEOUT_POPUP',
    };
};

export const invalidUser = (error) => {
    return {
        type: 'VALIDATE_CREDENTIALS_FAILURE',
        payload: error,
    };
};

export const fetchSecurityQuestion = (securityQuestion) => {
    return {
        type: 'SET_SECURITY_QUESTION',
        payload: securityQuestion,
    };
};

export const clearErrorMessage = () => {
    return {
        type: 'CLEAR_ERROR_MESSAGE',
    };
};

export const serverError = (data) => {
    return {
        type: 'SERVER_ERROR',
        payload: data,
    };
};

export const setSuccessMessage = (data) => {
    return {
        type: 'SET_SUCCESS_MESSAGE',
        payload: data,
    };
};

export const clearSuccessMessage = () => {
    return {
        type: 'CLEAR_SUCCESS_MESSAGE',
        payload: { status: null, statusText: null },
    };
};

export const incrementSessionRefreshTimer = () => {
    return {
        type: 'INCREMENT_SESSION_REFRESH_TIMER',
    };
};

export const resetSessionRefreshTimer = () => {
    return {
        type: 'RESET_SESSION_REFRESH_TIMER',
    };
};

export const setCustIdTnxArray = (paymentDetails) => {
    return {
        type: 'SET_CUSTID_TNXARRAY',
        payload: paymentDetails,
    };
};

export const resetCustIdTnxArray = () => {
    return {
        type: 'RESET_CUSTID_TNXARRAY',
    };
};

export const setStagePaymentId = (stagePaymentId) => {
    return {
        type: 'SET_STAGE_PAYMENTID',
        payload: stagePaymentId,
    };
};

export const showDeleteLink = (allowDelete) => {
    return {
        type: 'SHOW_DELETE_LINK',
        payload: allowDelete,
    };
};

export const resetStagePaymentId = () => {
    return {
        type: 'RESET_STAGE_PAYMENTID',
    };
};

export const setRegistrationDetails = (registrationDetails) => {
    return {
        type: 'SET_REGISTRATION_DETAILS',
        payload: registrationDetails,
    };
};

export const resetRegistrationDetails = () => {
    return {
        type: 'RESET_REGISTRATION_DETAILS',
    };
};


export const fetchCustomerLogo = () => {
    return async (dispatch, getState) => {
        const FETCH_LOGO = process.env.REACT_APP_FETCH_LOGO;
        try {
            const response = await axiosInstance({
                method: 'get',
                url: FETCH_LOGO,
                responseType: 'blob',
            });
            console.log('Logging logo response', response);
            console.log('Logging logo response headers', response.headers.customername);
            console.log(`Logging LOGO`, response.data);
            console.log('URL.createObjectURL(response.data) Logo is', URL.createObjectURL(response.data));
            blobToBase64(response.data).then((res) => {
                // do what you wanna do
                console.log('Logging Blob to Base64', res); // res is base64 now
            });
            if (response.status === 200) {
                let data = {
                    customerLogo: response.data,
                    calledLogoApi: true,
                    logoAltText: response.headers.customername,
                };
                dispatch({ type: 'FETCH_CUSTOMER_LOGO', payload: data });
            }
            if (response.status === 204) {
                let data = {
                    customerLogo: null,
                    calledLogoApi: true,
                };
                dispatch({ type: 'FETCH_CUSTOMER_LOGO', payload: data });
            }
        } catch (error) {
            console.error(`Logging ${FETCH_LOGO} error`, error);
        }
    };
};

export const fetchConfig = () => {
    return async (dispatch, getState) => {
        const FETCH_CONFIG = '/config';
        try {
            const response = await axiosInstance({
                method: 'get',
                url: FETCH_CONFIG,
            });
            if (response.status === 200) {
                console.log(`Logging Config`, response.data);
                let captchaConfig = response.data;
                dispatch({ type: 'SET_CAPTCHA_CONFIG', payload: captchaConfig });
            }
        } catch (error) {
            console.error(`Logging ${FETCH_CONFIG} error`, error);
        }
    };
};

export const setCaptchaHeader = (token) => {
    return {
        type: 'SET_CAPTCHA_TOKEN',
        payload: token,
    };
};
